import Accordion from "./imports/accordion.js";
import Carousel from "./imports/carousel.js";
import ClearForm from "./imports/clear-form.js";
import Comparison from "./imports/comparison.js";
import Facet from "./imports/facet.js";
import Gallery from "./imports/gallery.js";
import HeroPattern from "./imports/hero-pattern.js";
import HeroVideo from "./imports/hero-video.js";
import HotspotImage from "./imports/hotspot-image.js";
import InternalNav from "./imports/internal-nav.js";
import OffCanvas from "./imports/off-canvas.js";
import ResponsiveTable from "./imports/responsive-table.js";
import ScrollbarWidth from "./imports/scrollbar-width.js";
import ScrollSpy from "./imports/scroll-spy.js";
import Tabs from "./imports/tabs.js";

export default function initializeApp() {
  // Polyfills
  if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
  }
  if (window.HTMLCollection && !HTMLCollection.prototype.forEach) {
    HTMLCollection.prototype.forEach = Array.prototype.forEach;
  }

  // Initialize components
  Accordion();
  Carousel();
  ClearForm();
  Comparison();
  Facet();
  Gallery();
  HeroPattern();
  HeroVideo();
  HotspotImage();
  InternalNav();
  OffCanvas();
  ResponsiveTable();
  ScrollbarWidth();
  ScrollSpy();
  Tabs();
}

if (typeof window !== "undefined") {
  initializeApp();
}
